// extracted by mini-css-extract-plugin
export default {"root":"Row_root__mBikB"};